import React, { useState } from "react";
import ReusableTable from "../../common/ReusableComponent/reusableTable/ReusableTable";
import useApi from "../../../utils/api-manager/Helper/useApi";
const AuditLogs = () => {
  const [loading, setLoading] = useState(false);
  const { GetPaginatedData } = useApi();
  const fetchAuditLogs = async ({ page = 1, searchTerm = "" } = {}) => {
    try {
      const response = await GetPaginatedData('auditLog', {
        page,
        search: searchTerm
      });
      const transformedData = response.data.map(item => ({
        ...item,
        user_name: item.user ? `${item.user.first_name} ${item.user.last_name}` : 'N/A',
        main_store_name: item.user?.main_store_name || 'N/A',
        formatted_timestamp: new Date(item.timestamp).toLocaleString()
      }));
      return {
        data: transformedData,
        totalPages: Math.ceil(response.totalCount / 10)
      };
    } catch (error) {
      console.error('Error fetching audit logs:', error);
      return {
        data: [],
        totalPages: 1
      };
    }
  };
  const columns = [
    { header: "Name", field: "user_name" },
    { header: "Store", field: "main_store_name" },
    { header: "Service", field: "service_name" },
  ];
  return (
    <div className="responsive-box">
      <div className="inventory-header">
        <div className="inventory-title">
          <h2>Audit Logs</h2>
        </div>
      </div>
      <ReusableTable
        fetchData={fetchAuditLogs}
        columns={columns}
        showAction={false}
        showFooter={true}
        loading={loading}
      />
    </div>
  );
};
export default AuditLogs;